export const ORConditions = [
  "Sudjelovanje na minimalno 6 radionica",
  "Napisane sve introspekcije RAR-a",
  "Završen min. stupanj stručne spreme Baccalaureus ili više",
  "Suglasnost voditelja grupe za upis programa",
];

export const TP1Conditions = [
  "Završen min. stupanj stručne spreme Baccalaureus",
  "Napisane sve dospjele introspekcije",
  "Sudjelovanje na svim predavanjima, za OR min. 17 radionica po godini, a za eOR min. 14 radionica po godini i svim Modulima uživo sa min. 5 radionica po modulu",
  "Minimalno 25 sati IPR-a (programskih terapija)",
  "Suglasnost mentora za upis TP-a",
];

export const TP2Conditions = [
  "Sudjelovanje u svojstvu pasivnog promatrača  na minimalno: 6 Trijada, 3 AGS-a, 2 EPeR-a",
  "Sudjelovanje na svim predavanjima i min 17 radionica OR-a po godini",
  "Sudjelovanje na svim radionicama i predavanjima TP1",
  "Min 40 sati IPR-a Individualnih programskih terapija",
  "Napisane sve introspekcije",
  "Suglasnost mentora za upis u TP",
];

export const TTConditions = [
  "Minimalno 60 programskih terapija (OPR-a) kroz minimalno četiri godine",
  "Minimalno 90 sati Grupnog psihoterapijskog rada (GPR-a) kroz fakultativne programe Škole",
  "Napisan i uvezan Završni rad programa Osobni razvoj i sve introspekcije",
  "Suglasnost tri supervizora ili većinsku suglasnost Supervizorskog vijeća oko spremnosti Polaznika za prijem u TT na osnovu propisanih Kriterija za upis TT-a",
  "Minimalno ukupno 15 sati individualne supervizije: 1 na 1 ili kao izlagač na AGS-u",
  "Minimalno 20 sati besplatnog rada s klijentom",
  "Obranjena Studija slučaja 1 (CS1)",
  "Suglasnost mentora za upis TT-a",
];
